import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { pathjoin } from '@gandi/utils';
import Context from '../../Context';
import { Step } from './Step';
import { jsx as _jsx } from "react/jsx-runtime";
export function StepSaveCreditCard() {
  const {
    __
  } = useTranslator();
  const {
    sharingId,
    adminURL
  } = React.useContext(Context);
  return /*#__PURE__*/_jsx(Step, {
    iconName: "credit-card",
    title: __('Save a card and facilitate your next purchases.'),
    url: pathjoin(adminURL, 'billing', sharingId, 'payment-methods', 'add'),
    children: __('Your credit card details will be safely stored ' + 'at our payment gateway and you can delete or modify them at any time.')
  });
}